import { Component } from '@angular/core';
import {Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {ChallengeInApp} from "../../models/challenge-in-app";
import {ChallengeProvider} from "../../providers/challenge/challenge";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the AppChallengeInAppPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-in-app',
  templateUrl: 'app-challenge-in-app.html',
})
export class AppChallengeInAppPage {

  challenges: Array<ChallengeInApp>

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public challengeProvider: ChallengeProvider,
    public userState: UserStateProvider,
    private api: ApiProvider,
    public events: Events
  ) {
    this.challenges = this.challengeProvider.getInAppChallenges();
    this.events.subscribe('state:refreshed', () => {
      this.challenges = this.challengeProvider.getInAppChallenges();
    })


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppChallengeInAppPage');
  }

  ionViewWillEnter() {
    this.challenges = this.challengeProvider.getInAppChallenges();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-in-app/app-challenge-in-app.ts